/** Скрипт виджета Яндекс НДД (ПВЗ). */
export const YANDEX_NDD_WIDGET_SCRIPT = 'https://ndd-widget.landpro.site/widget.js';

/**
 * Станция отгрузки (GUID). Задаётся в .env: REACT_APP_YANDEX_NDD_STATION_ID.
 * Плейсхолдер из документации виджета — замените на свой в продакшене.
 */
export const yandexNddStationId =
    process.env.REACT_APP_YANDEX_NDD_STATION_ID || '05e809bb-4521-42d9-a936-0fb0744c0fb3';

export const yandexNddDefaultCity =
    process.env.REACT_APP_YANDEX_NDD_DEFAULT_CITY || 'Москва';

/** Масса посылки для расчёта доставки (виджет + фоновый offers/create). Переопределение: REACT_APP_YANDEX_NDD_WEIGHT_G. */
export const yandexNddWeightG = Number(process.env.REACT_APP_YANDEX_NDD_WEIGHT_G) || 3000;
